import React from 'react';
import {Message} from 'semantic-ui-react';

import {makeDBContentImageUrl} from 'utils/DBUtils';

class HomepageMessageBar extends React.Component {

  render() {

    return  <Message  color='purple'>
              {this.props.item.message}
            </Message>
  }

}

export default HomepageMessageBar;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/message-bar.jsx